import React, { useEffect, useState } from "react";
import { Modal, Radio, Select, Button, notification } from "antd";
import { BookOpen } from "lucide-react";
import {
  assignGuidesToBatch,
  getJobGuide,
} from "../../../api/globalAdmin/Index";
import WebUtils from "../../../utils/WebUtils";
import Utils from "../../../utils/Utils";
import {
  assignInterviewToBatches,
  assignInterviewToCandidates,
  getIMockInterviewData,
} from "../../../api/org-admin";

function AssignMockInterviewModal({
  setAssignMockInterviewModalFlag,
  assignMockInterviewModalFlag,
  setLoading,
  selectedUserIds,
  batchDetails,
  studentsData,
}) {
  const userDetail = Utils.getUserDetail();
  const batchId = window.location.pathname.split("/").pop();

  const [assignType, setAssignType] = useState("ALL");
  const [selectedInterview, setSelectedInterview] = useState([]);
  const [interviewData, setInterviewData] = useState([]);

  const getInterviewData = () => {
    const url = `${getIMockInterviewData}?organizationId=${userDetail.organizationId}`;
    setLoading(true);

    WebUtils.httpOperations(url, {}, "GET")
      .then((result) => {
        setLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          //   console.log(result.data.data);
          let data = result?.data?.data;
          setInterviewData(data);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  const assignToBatch = () => {
    let url = `${assignInterviewToBatches}?organizationId=${userDetail?.organizationId}&userIdentifier=${userDetail?.userIdentifier}&iDronaInterviewConfigurationId=${selectedInterview}`;

    let reqBody = {
      selectedInterview,
    };

    setLoading(true);
    WebUtils.httpOperations(url, [batchId], "POST")
      .then((result) => {
        setLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          notification.success({
            message: "Success",
            description: `${"Guides assign to batch! "}`,
            placement: "topRight",
            showProgress: true,
            duration: 2,
          });
          setAssignMockInterviewModalFlag(false);
        } else {
          notification.error({
            message: "Failed",
            description: `${result?.data?.resultStatusInfo?.message}`,
            placement: "topRight",
            // showProgress: true,
            duration: 2,
          });
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  const assignToStudents = () => {
    let url = `${assignInterviewToCandidates}?userIdentifier=${userDetail.userIdentifier}`;
    // let url = `${assignInterviewToCandidates}?userIdentifier=${userDetail.organizationId}&iDronaInterviewConfigurationId=${selectedInterview}&organizationId=${userDetail.organizationId}`;

    // console.log(studentsData,selectedUserIds)

    const selectedObj = studentsData.filter((item) =>
      selectedUserIds.includes(item.userId),
    );

    let reqBody = {
      organizationId: userDetail?.organizationId,
      batchIdentifier: batchDetails.batchIdentifier,
      batchName: batchDetails.batchName,
      candidateData: selectedObj,
      idronaInterviewConfigurationId: selectedInterview,
    };
    // console.log(reqBody)

    setLoading(true);
    WebUtils.httpOperations(url, reqBody, "POST")
      .then((result) => {
        setLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          notification.success({
            message: "Success",
            description: `${"Guides assign to students! "}`,
            placement: "topRight",
            showProgress: true,
            duration: 2,
          });
          setAssignMockInterviewModalFlag(false);
        } else if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "failure"
        ) {
          notification.error({
            message: "Failed",
            description: `${"Guides assign to students failed! "}`,
            placement: "topRight",
            showProgress: true,
            duration: 2,
          });
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  const handleSubmit = () => {
    if (assignType === "SELECTED") {
      assignToStudents();
    } else {
      assignToBatch();
    }
  };

  useEffect(() => {
    getInterviewData();
  }, []);

  useEffect(() => {
    if (assignMockInterviewModalFlag) {
      if (selectedUserIds?.length > 0) {
        setAssignType("SELECTED");
      } else {
        setAssignType("ALL");
      }
    }
  }, [assignMockInterviewModalFlag, selectedUserIds]);

  const interviewOptions = interviewData?.map((item) => ({
    label: (
      <div>
        <p className="font-medium mb-0">
          {item.jobTitle}{" "}
          <span className="text-[.75rem] text-gray-500">
            ({item.idronaInterviewConfigurationId})
          </span>
        </p>

        <p className="text-[.75rem] text-gray-500 mb-0">
          Created on{" "}
          {new Date(item.creationTime).toLocaleDateString("en-IN", {
            day: "2-digit",
            month: "short",
            year: "numeric",
          })}
        </p>
      </div>
    ),

    value: item.idronaInterviewConfigurationId,

    title: item.jobTitle,
  }));
  return (
    <Modal
      open={assignMockInterviewModalFlag}
      onCancel={() => setAssignMockInterviewModalFlag(false)}
      footer={null}
      centered
      width={550}
      title={
        <div className="flex items-center gap-2">
          <span className="p-[9px] rounded-lg border-[2px] border-gray-200 shadow-sm">
            {" "}
            <BookOpen size={22} color="#475467" />
          </span>
          <div>
            <p className="text-[1rem] font-semibold ">Assign mock interviews</p>
            <p className="text-[.78rem] font-normal sub-text-color">
              Assign mock interviews to help students prepare for interviews and
              assessments
            </p>
          </div>
        </div>
      }
    >
      <div className="mt-7">
        <Radio.Group
          value={assignType}
          onChange={(e) => setAssignType(e.target.value)}
          className=" custom-orange-radio"
        >
          <Radio value="ALL">
            Assign mock interview to all students in this batch
          </Radio>
          <Radio
            disabled={selectedUserIds?.length < 1}
            value="SELECTED"
            className="mt-2"
          >
            Assign mock interview to selected student
          </Radio>
        </Radio.Group>
      </div>

      <div className="mt-5">
        <p className="text-[.9rem] font-medium text-[#344054] mb-2">
          Select Interview
        </p>

        <Select
          allowClear
          className="w-full"
          size="large"
          placeholder="Select guides"
          value={selectedInterview}
          onChange={setSelectedInterview}
          options={interviewOptions}
          optionLabelProp="title"
        />
      </div>

      <div className="flex items-center gap-3 mt-6">
        <button
          className="btn-white px-3 py-2 rounded-lg sm:w-1/2 w-full"
          onClick={() => setAssignMockInterviewModalFlag(false)}
        >
          Cancel
        </button>

        <button
          disabled={selectedInterview?.length < 1}
          onClick={handleSubmit}
          className={` ${selectedInterview?.length < 1 ? "btn-disabled" : "btn-orange"} px-3 py-2 rounded-lg sm:w-1/2 w-full`}
        >
          Assign Mock Interview
        </button>
      </div>
    </Modal>
  );
}

export default AssignMockInterviewModal;
